import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const Home = () => import('@/views/Home')
const Production = () => import('@/views/Production')
const Carbon = () => import('@/views/Carbon')
const Pioneer = () => import('@/views/Pioneer')
const About = () => import('@/views/About')
const Server = () => import('@/views/Server')
// const ProductionBrain = () => import('@/components/production/ProductionBrain.vue')
// const YunZhaoShang = () => import('@/components/yun_zhaoshang/index.vue')
// const EnterInnovation = () => import('@/components/enter_innovation/index.vue')
// const Consulting = () => import('@/components/consulting/index.vue')
// const ReportList = () => import('@/components/report_list/index.vue')
// const NewsDetails = () => import('@/components/report_list/NewsDetails.vue')
// const NewsDetailsTwo = () => import('@/components/report_list/NewsDetailsTwo.vue')
// const Realize = () => import('@/components/realize/index.vue')

const routes = [
  {
    path: '',
    redirect: '/home',
    meta: {
      title: '首页',
      description: '中碳普惠云科技有限公司由具有海内外前沿科技研发和政策前瞻能力的北大清华创始团队+央企+国内算力独角兽企业共同发起，是一家聚焦于碳中和领域大模型算法和AI Agent创新应用的科技型企业',
      keywords: '中碳普惠云, 碳中和, 碳盘查, 碳足迹, ESG, 碳盘查报告'
    }
  },
  {
    path:'/home',
    component:Home,
    meta: {
      title: '首页',
      description: '中碳普惠云科技有限公司由具有海内外前沿科技研发和政策前瞻能力的北大清华创始团队+央企+国内算力独角兽企业共同发起，是一家聚焦于碳中和领域大模型算法和AI Agent创新应用的科技型企业',
      keywords: '中碳普惠云, 碳中和, Agent'
    }
  },
  {
    path:'/production',
    component:Production,
    meta: {
      title: 'LLM+AI Agent',
      description: '中碳普惠云科技有限公司由具有海内外前沿科技研发和政策前瞻能力的北大清华创始团队+央企+国内算力独角兽企业共同发起，是一家聚焦于碳中和领域大模型算法和AI Agent创新应用的科技型企业',
      keywords: '中碳普惠云, 碳中和, LLM+AI Agent, 大模型, AI Agent'
    }
  },
  {
    path:'/carbon',
    component:Carbon,
    meta: {
      title: '双探引领',
      description: '中碳普惠云科技有限公司由具有海内外前沿科技研发和政策前瞻能力的北大清华创始团队+央企+国内算力独角兽企业共同发起，是一家聚焦于碳中和领域大模型算法和AI Agent创新应用的科技型企业',
      keywords: '中碳普惠云, 碳中和, 双探引领'
    }
  },
  {
    path:'/pioneer',
    component:Pioneer,
    meta: {
      title: '可持续先锋',
      description: '中碳普惠云科技有限公司由具有海内外前沿科技研发和政策前瞻能力的北大清华创始团队+央企+国内算力独角兽企业共同发起，是一家聚焦于碳中和领域大模型算法和AI Agent创新应用的科技型企业',
      keywords: '中碳普惠云, 碳中和, 可持续先锋'
    }
  },
  {
    path:'/about',
    component:About,
    meta: {
      title: '关于我们',
      description: '中碳普惠云科技有限公司由具有海内外前沿科技研发和政策前瞻能力的北大清华创始团队+央企+国内算力独角兽企业共同发起，是一家聚焦于碳中和领域大模型算法和AI Agent创新应用的科技型企业',
      keywords: '中碳普惠云, 碳中和, 关于我们'
    }
  },
  {
    path:'/service',
    component:Server,
    meta: {
      title: '产品&服务',
      description: '中碳普惠云科技有限公司由具有海内外前沿科技研发和政策前瞻能力的北大清华创始团队+央企+国内算力独角兽企业共同发起，是一家聚焦于碳中和领域大模型算法和AI Agent创新应用的科技型企业',
      keywords: '中碳普惠云, 碳中和, 碳盘查, 碳盘查报告'
    }
  },
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router